let setRouter = function(data) {
    if (data && data.userMenuAuthority) {
        console.log(data.userMenuAuthority);
        return data.userMenuAuthority;
    } else {
        return []
    }
}

export default setRouter


// WEBPACK FOOTER //
// ./src/router/default.js